import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobile_menu_icon_dropdown",
  "use": "mobile_menu_icon_dropdown-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"mobile_menu_icon_dropdown\"><path d=\"m13.622 7.767-3.535 3.535L6.55 7.767A.907.907 0 1 0 5.267 9.05l4.182 4.182a.908.908 0 0 0 1.284 0l4.183-4.182a.907.907 0 0 0 0-1.284.927.927 0 0 0-1.294 0Z\" fill=\"#2C2D2E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol